import { makeStyles } from '@material-ui/core/styles'

export default makeStyles({
  root: {
    position: 'relative'
  },
  h3: {
    color: '#FDB72A',
    fontSize: 28,
    fontWeight: 300,
    marginBottom: 5
  },
  body1: {
    color: 'white',
    fontSize: 15,
    fontWeight: 300
  },
  beanContent: {
    height: '100px',
    position: 'absolute',
    bottom: 10,
    left: 0,
    width: '100%',
    overflow: 'hidden'
  }
})
